import { useEffect } from 'react';

interface Options {
  type?: string;
  async?: boolean;
  defer?: boolean;
  onCreate?: () => void;
  onLoad?: ((this: GlobalEventHandlers, ev: Event) => any) | null;
  onError?: OnErrorEventHandler;
}

export function useScript(
  src: string,
  {
    onCreate,
    onLoad,
    onError,
    type = 'text/javascript',
    async = true,
    defer = false,
  }: Options,
) {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = src;

    script.setAttribute('type', type);
    script.setAttribute('async', async ? 'true' : 'false');
    script.setAttribute('defer', defer ? 'true' : 'false');

    if (onLoad) {
      script.onload = onLoad;
    }

    if (onError) {
      script.onerror = onError;
    }

    document.body.appendChild(script);

    onCreate && onCreate();
    return () => {
      document.body.removeChild(script);
    };
  }, []);
}
